// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    mygistecUrl: "https://localhost:4200",
    apiEndPoint: 'https://localhost:7029/api/2.1.0/',
    HubsURL: {
        //"Notifications": "https://my.gistec.com/my.gistec.v2/my.gistec.api/notify",
        "Notifications": "https://localhost:7029/notify",
    },
    firebase: {
        apiKey: "AIzaSyAwNiwAUkt5P6HGQTEM194EgTpSU4PeODY",
        authDomain: "mygistec-92f39.firebaseapp.com",
        projectId: "mygistec-92f39",
        storageBucket: "mygistec-92f39.appspot.com",
        messagingSenderId: "826461428621",
        appId: "1:826461428621:web:f39da0567e14fc0fa8bbc4",
        measurementId: "G-6ZWE7R7573"
    },
    linkedInCredentials: {
        authorizationUrl: "https://www.linkedin.com/uas/oauth2/authorization",
        response_type : "code",
        clientId: "77twxkugiuaqgn",
        redirectUrl: "https://localhost:4200/auth/linkedin",
        scope: "r_liteprofile%20r_emailaddress" // To read basic user profile data and email
    },
    googleCredentials: {
        issuer: "https://accounts.google.com",
        strictDiscoveryDocumentValidation: false,
        redirectUri: "https://localhost:4200/auth/google",
        clientId: "132490776477-1p19pjh44jk4mu938qldm2kjkq1ua790.apps.googleusercontent.com",
        scope: "openid profile email"
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
